import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

const BASE_URL = `${API_URL}/review-cycle`;

export function getReviewCycleSummary(cycleId: string, reviewIds?: string[]) {
    return post<string>(`${BASE_URL}/${cycleId}/summary`, { postData: { reviewIds } });
}
